export enum EFetchingStatus {
  Loaded,
  InProgress,
  NotAvailable,
  Error,
}
